export default () => ({
  handler: 'relativeUrl',
  data: ({ ctcType }) => ({
    STANDARD: '/crack-the-code',
    RAFFLE: '/raffle',
  }[ctcType] || '/crack-the-code'),
});
